// extracted by mini-css-extract-plugin
export default {"container":"type-selector_container__+Bayq"};